module.exports = __webpack_public_path__ + "bec446a5c33936e90547b6ba6c9ef570.svg";